import { useState, useEffect, useCallback, useRef } from 'react';

const PORTFOLIO = [
  {
    img: 'https://cdn1.npcdn.net/images/9557c69fba51fbce240b2e115031a8cd_1706772130.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=png&type=1',
    title: 'ASTRO \u300aU\u864e\u52a0\u628a\u52b2\u300b2021 \u8d3a\u5c81\u4e13\u8f91 (\u864e\u864eGongxi Bersama)',
  },
  {
    img: 'https://cdn1.npcdn.net/images/c810848193f13d401669da8ed069dc6b_1706772031.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=png&type=1',
    title: 'ASTRO & \u5f00\u5fc3\u9f99\u9f99WAY & 2024 \u8d3a\u5c81\u4e13\u8f91 (\u8fc7\u5927\u5927\u7684\u5e74)',
  },
  {
    img: 'https://cdn1.npcdn.net/images/53ec2687502dc1995cd37b4dd966e1d4_1706771796.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=png&type=1',
    title: 'Vogue for Virtue Fashion Show',
  },
  {
    img: 'https://cdn1.npcdn.net/images/dccd419d63dffc5419248a9c1b61eb1c_1706771699.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=png&type=1',
    title: "F&N Beverage TVC (70's Theme)",
  },
  {
    img: 'https://cdn1.npcdn.net/images/fec2a513341b8db9faa3aa405a9be529_1710323737.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&w=1735522370&from=jpeg&type=9',
    title: 'Money No Enough 3 \u9322\u4e0d\u591f\u7528 3',
  },
  {
    img: 'https://cdn1.npcdn.net/images/f9567feb2f2a0f1444350b4e7ed9ec5a_1710323586.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&w=1735522370&from=jpeg&type=9',
    title: 'The King of Musang King \u732b\u5c71\u738b\u4e2d\u738b',
  },
  {
    img: 'https://cdn1.npcdn.net/images/7d10e889d55f17a1487da055de23b116_1706772595.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=png&type=1',
    title: 'Walking With You S4 \u300a\u5fc3\u5ea6\u67094\u300b \u8282\u76ee',
  },
  {
    img: 'https://cdn1.npcdn.net/images/3e4e3f4ccb910c36ae6cfc862805a4c9_1706772432.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=png&type=1',
    title: 'ASTRO CGM 2023 \u300a\u7ecf\u5178\u540d\u66f2\u6b4c\u5531\u5927\u8d5b 2023\u300b \u8282\u76ee',
  },
  {
    img: 'https://cdn1.npcdn.net/images/be42340fd7c3d6bc80765cb7f71ade96_1706771608.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=png&type=1',
    title: '100 Plus TVC',
  },
  {
    img: 'https://cdn1.npcdn.net/images/98e78e7f8f07706142f7ad1bcb6737ec_1706771439.webp?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=1000&new_height=1000&size=max&w=1735522370&from=jpeg&type=1',
    title: 'War On Terror',
  },
];

const AUTO_INTERVAL = 3000;

export default function PortfolioSection() {
  const [start, setStart] = useState(0);
  const [visible, setVisible] = useState(4);
  const [paused, setPaused] = useState(false);
  const [animating, setAnimating] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const updateVisible = () => {
      if (window.innerWidth < 640) setVisible(1);
      else if (window.innerWidth < 768) setVisible(2);
      else if (window.innerWidth < 1024) setVisible(3);
      else setVisible(4);
    };
    updateVisible();
    window.addEventListener('resize', updateVisible);
    return () => window.removeEventListener('resize', updateVisible);
  }, []);

  useEffect(() => {
    setStart(s => Math.min(s, Math.max(0, PORTFOLIO.length - visible)));
  }, [visible]);

  const goNext = useCallback(() => {
    if (animating) return;
    setAnimating(true);
    setStart(s => (s + 1 >= PORTFOLIO.length - visible + 1 ? 0 : s + 1));
    setTimeout(() => setAnimating(false), 400);
  }, [animating, visible]);

  const goPrev = useCallback(() => {
    if (animating) return;
    setAnimating(true);
    setStart(s => (s - 1 < 0 ? PORTFOLIO.length - visible : s - 1));
    setTimeout(() => setAnimating(false), 400);
  }, [animating, visible]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(goNext, AUTO_INTERVAL);
  }, [goNext]);

  useEffect(() => {
    if (paused) {
      if (timerRef.current) clearInterval(timerRef.current);
      return;
    }
    timerRef.current = setInterval(goNext, AUTO_INTERVAL);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [paused, goNext]);

  const handlePrev = () => { goPrev(); resetTimer(); };
  const handleNext = () => { goNext(); resetTimer(); };

  const totalPages = PORTFOLIO.length - visible + 1;
  const currentPage = start;

  return (
    <section id="portfolio" className="py-10 sm:py-16 bg-white">
      <div className="text-center mb-8 sm:mb-10 px-4">
        <h2 className="text-3xl sm:text-4xl text-gray-800" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Portfolio
        </h2>
      </div>

      <div
        className="relative px-8 sm:px-12"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        {/* Prev arrow */}
        <button
          onClick={handlePrev}
          className="absolute left-1 sm:left-2 top-1/3 -translate-y-1/2 w-7 h-7 sm:w-9 sm:h-9 flex items-center justify-center bg-white border border-gray-200 rounded-full hover:bg-gray-100 cursor-pointer z-10 transition-all"
        >
          <i className="ri-arrow-left-s-line text-lg sm:text-xl text-gray-700" />
        </button>

        {/* Items */}
        <div
          className={`grid gap-3 sm:gap-4 overflow-hidden transition-opacity duration-300 ${animating ? 'opacity-0' : 'opacity-100'}`}
          style={{ gridTemplateColumns: `repeat(${visible}, minmax(0, 1fr))` }}
        >
          {PORTFOLIO.slice(start, start + visible).map((item, i) => (
            <div key={`${start}-${i}`} className="group cursor-pointer">
              <div className="relative overflow-hidden" style={{ aspectRatio: '1/1' }}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                  <span className="text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 tracking-widest uppercase">
                    View Details
                  </span>
                </div>
              </div>
              <div className="mt-2 sm:mt-3 text-center">
                <h6 className="text-xs sm:text-sm text-gray-700 font-medium leading-snug">{item.title}</h6>
              </div>
            </div>
          ))}
        </div>

        {/* Next arrow */}
        <button
          onClick={handleNext}
          className="absolute right-1 sm:right-2 top-1/3 -translate-y-1/2 w-7 h-7 sm:w-9 sm:h-9 flex items-center justify-center bg-white border border-gray-200 rounded-full hover:bg-gray-100 cursor-pointer z-10 transition-all"
        >
          <i className="ri-arrow-right-s-line text-lg sm:text-xl text-gray-700" />
        </button>
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center gap-1.5 mt-6">
        {Array.from({ length: totalPages }).map((_, i) => (
          <button
            key={i}
            onClick={() => { setStart(i); resetTimer(); }}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              i === currentPage ? 'bg-gray-800 w-5' : 'bg-gray-300 w-1.5'
            }`}
          />
        ))}
      </div>
    </section>
  );
}
